module.exports = __webpack_public_path__ + "static/img/95508.a55fc00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/95508.png
// module id = cCqO
// module chunks = 18